import { Settings, defaults } from './profile';
// Original adaptive score, synthesized locally. No streaming or licensed recordings.
class GameAudio {
    private context: AudioContext | null = null;
    private timer: ReturnType<typeof setInterval> | null = null;
    private step = 0;
    private mode = 'menu';
    private settings = { ...defaults };
    configure(settings: Settings) { this.settings = settings; }
    start() { if (!this.context) {
        try {
            this.context = new AudioContext();
        }
        catch {
            return;
        }
    } void this.context.resume(); if (!this.timer)
        this.timer = setInterval(() => this.music(), 320); }
    setMode(mode: string) { this.mode = mode; }
    private tone(freq: number, duration: number, volume: number, wave: OscillatorType = 'sine', delay = 0, end?: number) { const c = this.context; if (!c || this.settings.master === 0)
        return; const osc = c.createOscillator(), g = c.createGain(); osc.type = wave; osc.frequency.setValueAtTime(freq, c.currentTime + delay); if (end)
        osc.frequency.exponentialRampToValueAtTime(end, c.currentTime + delay + duration); g.gain.setValueAtTime(0, c.currentTime + delay); g.gain.linearRampToValueAtTime(volume * this.settings.master, c.currentTime + delay + .025); g.gain.exponentialRampToValueAtTime(.0001, c.currentTime + delay + duration); osc.connect(g); g.connect(c.destination); osc.start(c.currentTime + delay); osc.stop(c.currentTime + delay + duration + .05); }
    private music() {
        if (document.hidden)
            return;
        const battle = this.mode === 'battle';
        const scale = [146.83, 174.61, 220, 261.63, 293.66, 349.23, 440, 523.25];
        const melody = [0, 2, 4, 2, 1, 3, 5, 3, 0, 2, 6, 4, 3, 2, 1, 2];
        const i = this.step++;
        if (i % 2 === 0)
            this.tone(scale[melody[Math.floor(i / 2) % 16]], battle ? .8 : 1.8, .07 * this.settings.music, 'sine');
        if (i % 8 === 0) {
            const root = [73.42, 65.41, 87.31, 55][Math.floor(i / 8) % 4];
            [1, 1.5, 2].forEach((v, j) => this.tone(root * v, 3, .035 * this.settings.music, 'triangle', j * .05));
            this.tone(root / 2, 3.5, .025 * this.settings.ambience, 'sine');
        }
        if (battle && i % 4 === 0)
            this.tone(85, .18, .1 * this.settings.music, 'sine', 0, 35);
    }
    play(cue: 'click' | 'draft' | 'hit' | 'clear' | 'warning' | 'ko' | 'cast' | 'story' | 'victory') { const v = this.settings.effects; switch (cue) {
        case 'click':
            this.tone(620, .07, .1 * v, 'triangle');
            break;
        case 'hit':
            this.tone(150, .07, .045 * v, 'triangle', 0, 60);
            break;
        case 'draft':
            [293.66, 349.23, 440, 587.33].forEach((n, i) => this.tone(n, .65, .13 * v, 'sine', i * .1));
            break;
        case 'clear':
            [440, 554.37, 659.25].forEach((n, i) => this.tone(n, .7, .12 * v, 'sine', i * .1));
            break;
        case 'warning':
            this.tone(220, .4, .18 * v, 'triangle');
            this.tone(220, .4, .18 * v, 'triangle', .5);
            break;
        case 'ko':
            this.tone(220, .45, .12 * v, 'triangle', 0, 73);
            break;
        case 'cast':
            this.tone(220, .65, .1 * v, 'sine', 0, 880);
            break;
        case 'story':
            this.tone(440, .2, .05 * this.settings.dialogue);
            break;
        case 'victory': [293.66, 369.99, 440, 587.33, 739.99, 880].forEach((n, i) => this.tone(n, 1.8, .13 * v, 'sine', i * .15));
    } }
}
export const audio = new GameAudio();
